import {WorkPosition} from "./WorkPosition";

export const WorkPositionNames: Record<WorkPosition, string> = {
  [WorkPosition.FIELD_OPERATOR]: "Operador de Campo",
  [WorkPosition.TECHNICAL_ANALYST]: "Analista Tecnico",
  [WorkPosition.ASSISTANT]: "Asistente",
};